<template>
  <div class="room-structure-container">
    <el-row :gutter="20">
      <el-col :span="4">
        <floor-unit-tree
          ref="floorUnitTree"
          @switchFloorUnit="switchFloorUnit"
        />
      </el-col>
      <el-col :span="20">
        <!-- 楼层总数小于2时平铺 -->
        <el-card
          v-if="Object.keys(roomStructureInfo.floorRooms).length < 2"
          class="room-list-card"
        >
          <el-row :gutter="10">
            <el-col
              v-for="(room, index) in roomStructureInfo.rooms"
              :key="index"
              :xs="12"
              :sm="8"
              :md="6"
              :lg="4"
              :xl="3"
              class="room-item"
            >
              <div
                class="room-card"
                :style="{ 'background-color': getBgColor(room) }"
                @click="toSimplifyAcceptance(room)"
              >
                <div class="room-number">
                  {{ room.floorNum }}-{{ room.unitNum }}-{{ room.roomNum }}
                </div>
                <div class="room-state">  {{
                      room.business === "1" ? "意向客户" : room.stateName || ""
                    }}</div>
                <div class="room-owner">
                  {{ room.ownerName || $t("roomStructure.noOwner") }}
                </div>
                <!-- <div class="room-debt">
                  <span>{{ $t("roomStructure.owe") }}</span
                  >：{{ room.oweAmount }}
                  <span>{{ $t("roomStructure.yuan") }}</span>
                </div> -->
              </div>
            </el-col>
          </el-row>
        </el-card>

        <!-- 多个楼层分层展示 -->
        <el-card v-else class="room-list-card">
          <div
            v-for="(roomList, unitName, index) in sortedFloorRooms"
            :key="index"
          >
            <!-- 直接展示接口原始unitNum，保留空格：2 F -->
            <div class="floor-title">{{ unitName }}</div>
            <el-row :gutter="10" class="floor-row">
              <el-col
                v-for="(room, idx) in roomList"
                :key="idx"
                :xs="12"
                :sm="8"
                :md="6"
                :lg="4"
                :xl="3"
                class="room-item"
              >
                <div
                  class="room-card"
                  :style="{ 'background-color': getBgColor(room) }"
                  @click="toSimplifyAcceptance(room)"
                >
                  <div class="room-number">
                    {{ room.floorNum }}-{{ room.unitNum }}-{{ room.roomNum }}
                  </div>
                  <div class="room-state">
                    {{
                      room.business === "1" ? "意向客户" : room.stateName || ""
                    }}
                  </div>
                  <div class="room-owner">
                    {{ room.ownerName || $t("roomStructure.noOwner") }}
                  </div>
                  <!-- <div class="room-debt">
                    <span>{{ $t("roomStructure.owe") }}</span
                    >：{{ room.oweAmount }}
                    <span>{{ $t("roomStructure.yuan") }}</span>
                  </div> -->
                </div>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import floorUnitTree from "@/components/room/floorUnitTree";
import { listRoomStructure } from "@/api/room/roomStructureApi";
import { getCommunityId } from "@/api/community/communityApi";

export default {
  name: "RoomStructureList",
  components: {
    floorUnitTree,
  },
  data() {
    return {
      roomStructureInfo: {
        rooms: [],
        floorRooms: {},
      },
      communityId: "",
    };
  },
  computed: {
    sortedFloorRooms() {
      const raw = this.roomStructureInfo.floorRooms;
      const sortedKeys = Object.keys(raw).sort((a, b) => {
        // 只提取数字排序，忽略空格
        const numA = parseInt(a.replace(/[^0-9]/g, ""));
        const numB = parseInt(b.replace(/[^0-9]/g, ""));
        return numA - numB;
      });
      const result = {};
      sortedKeys.forEach((key) => {
        result[key] = raw[key];
      });
      return result;
    },
  },
  created() {
    this.communityId = getCommunityId();
    setTimeout(() => {
      this.$refs.floorUnitTree.selectFirstUnit();
    }, 1500);
  },
  methods: {
    switchFloorUnit(data) {
      console.log("点击节点数据：", data);
      const floorId = data.floorId;
      const unitId = data.unitId;
      this.loadRooms(floorId, unitId);
    },

    async loadRooms(floorId, unitId) {
      console.log("入参 floorId=", floorId, "unitId=", unitId);
      this.roomStructureInfo.rooms = [];
      this.roomStructureInfo.floorRooms = {};

      try {
        const params = {
          page: 1,
          row: 1000,
          communityId: this.communityId,
        };
        if (floorId) {
          params.floorId = floorId;
        } else if (unitId) {
          params.unitId = unitId;
        }
        console.log("请求参数：", params);

        const { data } = await listRoomStructure(params);
        console.log("返回房屋数据：", data);
        this.roomStructureInfo.rooms = data;
        this.groupByUnitNum();
      } catch (error) {
        console.error("加载房屋失败：", error);
      }
    },

    groupByUnitNum() {
      const floorRooms = {};
      const roomList = this.roomStructureInfo.rooms || [];
      if (roomList.length === 0) return;

      roomList.forEach((item) => {
        // 不清除空格，直接使用原始unitNum作为key："2 F"
        const floorKey = item.unitNum;
        if (!floorRooms[floorKey]) {
          floorRooms[floorKey] = [];
        }
        floorRooms[floorKey].push(item);
      });

      this.roomStructureInfo.floorRooms = floorRooms;
    },

    getBgColor(room) {
      if (room.state === "2001" && room.business === "1") return "#DAA520";
      if (room.state === "2001") return "#2ECC71";
      if (room.state === "2002") return "#D3D3D3";
      if (room.state === "2004") return "#FF0000";
      if (room.state === "2010") return "#FFD700";
      if (room.state === "2011") return "#00BFFF";
      return "#1296db";
    },

    toSimplifyAcceptance(room) {
      this.$router.push(
        `/pages/property/simplifyAcceptance?tab=业务受理&searchType=1&searchValue=${room.floorNum}-${room.unitNum}-${room.roomNum}`,
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.room-structure-container {
  padding: 20px;
  height: 100%;

  .room-list-card {
    margin-bottom: 20px;
    min-height: calc(100vh - 120px);

    .floor-title {
      font-size: 16px;
      font-weight: bold;
      padding: 10px 0;
      color: #333;
      border-bottom: 1px solid #eee;
      margin-bottom: 10px;
    }

    .floor-row {
      margin-bottom: 20px;
    }

    .room-item {
      margin-bottom: 10px;
    }

    .room-card {
      color: #fff;
      border-radius: 5px;
      padding: 10px;
      cursor: pointer;
      transition: all 0.3s;
      height: 100%;

      &:hover {
        transform: translateY(-3px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      }

      .room-number {
        font-weight: bold;
        margin-bottom: 5px;
      }

      .room-state,
      .room-owner,
      .room-debt {
        margin-bottom: 3px;
        font-size: 12px;
      }
    }
  }
}
</style>
